export default __webpack_public_path__ + "static/LogoNewToken-1b8b4fe5f4de8e14be2660234123071a.svg";